import { render, staticRenderFns } from "./ProductRowGrid.vue?vue&type=template&id=f34ffd9e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ProductRowGrid.vue?vue&type=script&lang=ts"
export * from "./ProductRowGrid.vue?vue&type=script&lang=ts"
import style0 from "./ProductRowGrid.vue?vue&type=style&index=0&id=f34ffd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34ffd9e",
  null
  
)

export default component.exports